import { resolveConfidenceVisitorId } from "@helpers/confidenceVisitorId"
import {
  addFacebookParamsToLocalStorage,
  FACEBOOK_CLICK_ID_KEY,
} from "@helpers/localStorage"
import { applyTrackerUserId } from "@helpers/trackerUserId"
import LoadingPage from "@pages/LoadingPage"
import { trackPageView } from "@snowplow/browser-tracker"
import Cookies from "js-cookie"
import { useEffect, useState } from "react"
import { Outlet, ScrollRestoration, useLocation } from "react-router-dom"

export default function RootOutlet() {
  const [isReady, setIsReady] = useState<boolean>(false)

  const location = useLocation()

  useEffect(() => {
    // The auth listener may have reported the account before the tracker
    // existed, in which case that call went nowhere. A page view can only run
    // once the tracker is up, so this is the first safe moment to apply it.
    applyTrackerUserId()

    trackPageView({
      context: [
        {
          schema: "iglu:com.asanarebel/marketing_ids/jsonschema/1-0-1",
          data: {
            fbc:
              Cookies.get("_fbc") ??
              localStorage.getItem(FACEBOOK_CLICK_ID_KEY),
            fbp: Cookies.get("_fbp"),
          },
        },
        {
          schema: "iglu:com.asanarebel/confidence_visitor_id/jsonschema/1-0-0",
          data: {
            // Read through the resolver rather than straight from the cookie.
            // On iOS in-app browsers the cookie disappears partway through a
            // page load, which is what made this field "unknown" on every view
            // after the first.
            id: resolveConfidenceVisitorId() ?? "unknown",
          },
        },
      ],
    })
  }, [location])

  useEffect(() => {
    addFacebookParamsToLocalStorage(location.search)
    // NOTE: Initially wait one second to let the Facebook Pixel do its job and
    // add Facebook params to local storage.
    const setReadyWithTimeout = setTimeout(() => {
      setIsReady(true)
    }, 1000)

    return () => clearTimeout(setReadyWithTimeout)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <ScrollRestoration />
      {isReady ? <Outlet /> : <LoadingPage />}
    </>
  )
}
